var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconToastSuccess(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.91699 11.5C1.91699 6.21958 6.21991 1.91666 11.5003 1.91666C16.7807 1.91666 21.0837 6.21958 21.0837 11.5C21.0837 16.7804 16.7807 21.0833 11.5003 21.0833C6.21991 21.0833 1.91699 16.7804 1.91699 11.5ZM16.0509 9.59933C16.4255 9.2254 16.4261 8.61862 16.0521 8.24404C15.6782 7.86946 15.0714 7.86892 14.6969 8.24284L10.2073 12.7245L8.30533 10.8225C7.93108 10.4482 7.32429 10.4482 6.95004 10.8225C6.57579 11.1967 6.57579 11.8035 6.95004 12.1778L9.52908 14.7568C9.9031 15.1308 10.5094 15.1311 10.8838 14.7574L16.0509 9.59933Z",
    fill: "#47BE7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToastSuccess);
export default __webpack_public_path__ + "static/media/icon-toast-success.977b186a6327e895be8dedaf034bb1e6.svg";
export { ForwardRef as ReactComponent };